import { useCallback, useMemo } from 'react';
import { useLocation } from 'react-router';
import useInitializeMarketStateStore from 'hooks/useInitializeMarketStateStore';
import { isMarketStateSet } from 'utils/isMarketStateSet';
import { logAnalytics } from 'utils/logAnalytics';
import { MarketInput } from 'generated/graphql';

export const DEFAULT_ADMIN_PROFILE_ID = '0';
export const DEFAULT_EMPTY_ID_STATE = '';

/**
 *
 * @returns
 * Hook to manage market input state and log analytics on changes.
 */
const useMarketInput = () => {
  const { input: marketInput, setInput: storeSetInput } = useInitializeMarketStateStore();
  const location = useLocation();

  const handleSetInput = useCallback(
    (input: Partial<MarketInput>) => {
      storeSetInput(input);
      Object.keys(input).forEach((key) => {
        const value = (input as any)[key];
        logAnalytics(`update_market_${key}`, {
          [key]: JSON.stringify(value),
          path_location: location.pathname,
        });
      });
    },
    [storeSetInput, location.pathname],
  );

  const isMarketStateInitialized = useMemo(() => isMarketStateSet(marketInput), [marketInput]);

  return {
    marketInput,
    isMarketStateInitialized,
    onInputChange: handleSetInput,
  };
};
export default useMarketInput;
